import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import './app/core/editor/quill-semantic-html';
import './app/core/calendar/calendar-fixes';
import './app/core/select/select-fixes';
import './app/core/sidebar/sidebar-fixes';


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
